// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  font-family: 'Outfit', sans-serif;
}

:root {
  --text-color: #4d4d4d;
  --text-color-light: #979797;
}

body {
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: var(--text-color);
}

header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}

main {
  flex: auto;
  display: flex;
  flex-direction: column;
}

#search-container {
  flex: 1;
  margin: 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#search-container > div:first-child {
  font-weight: 600;
}

#search-form {
  margin-top: 10px;
}

#location-input {
  padding: 5px 10px;
  width: 300px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

#location-button {
  padding: 5px 10px;
  margin-left: 5px;
}

#settings-container {
  position: absolute;
  right: 50px;
  top: 50px;
}

/* Button from https://codepen.io/alvarotrigo/pen/oNoJePo*/

.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.button {
  position: relative;
  top: 50%;
  width: 74px;
  height: 36px;
  margin: -20px auto 0 auto;
  overflow: hidden;
}

.button.r,
.button.r .layer {
  border-radius: 100px;
}

.checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.knobs {
  z-index: 2;
}

.layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}
#metric-imperial-button .knobs:before {
  content: 'ºC';
  position: absolute;
  top: 4px;
  left: 4px;
  width: 20px;
  height: 10px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 9px 4px;
  background-color: #03a9f4;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#metric-imperial-button .checkbox:checked + .knobs:before {
  content: 'ºF';
  left: 42px;
  background-color: #f44336;
}

#metric-imperial-button .checkbox:checked ~ .layer {
  background-color: #fcebeb;
}

#metric-imperial-button .knobs,
#metric-imperial-button .knobs:before,
#metric-imperial-button .layer {
  transition: 0.3s ease all;
}

/* End Button */

/* #weather-container {
  flex: 5;
  display: none;
  grid-template-rows: 2fr 2fr 1fr;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    'current-container forecast-24h-container'
    'current-container forecast-daily-container'
    'spacer-container spacer-container';
  gap: 20px;
} */

#weather-container {
  flex: 5;
  display: none;
  flex-direction: row;
  justify-content: center;
  padding-top: 10vh;
  padding: 10vh 10px 0 10px;
}

#current-container {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: flex-start;
  margin-right: 20px;
}

#current-container > div:last-child {
  display: flex;
}

#current-location-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 15px;
}

#current-city {
  font-size: 32px;
  font-weight: 600;
}

#current-country {
  font-size: 24px;
}

#favorite-heart {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: 4px;
}

#favorite-heart:hover {
  transform: scale(1.1);
}

#last-updated {
  color: var(--text-color-light);
  font-size: 13px;
  margin-bottom: 20px;
}

#current-weather-icon {
  width: 150px;
  height: 150px;
}

#current-weather-description {
  text-align: center;
  font-size: 18px;
}

#current-conditions {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 24px;
}

#feels-like {
  color: var(--text-color-light);
  font-size: 15px;
  margin-bottom: 10px;
  text-align: center;
}

#current-precipitation {
  margin-bottom: 10px;
}

#wind-direction {
  width: 100px;
}

#forecast-container {
  display: flex;
  flex-direction: column;
}

#forecast-24h-container {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

#forecast-24h-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
}

#forecast-24h-cards {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  overflow-x: visible;
}

@media (max-width: 670px) {
  #forecast-24h-cards {
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 0.5rem;
    scrollbar-width: thin;
  }
}

#forecast-24h-cards::-webkit-scrollbar {
  height: 6px;
}

#forecast-24h-cards::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

#forecast-24h-cards::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.forecast-24h-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid var(--text-color-light);
  border-radius: 6px;
  width: 90px;
  padding: 0.75rem 0.25rem;
}

@media (max-width: 670px) {
  .forecast-24h-card {
    flex-shrink: 0;
    padding: 0.75rem 0.5rem;
    width: 80px;
  }
}

.forecast-24h-time {
  margin-bottom: 5px;
}

.forecast-24h-description {
  margin-bottom: 5px;
  font-size: 12px;
  text-align: center;
}

.forecast-24h-temperature {
  margin-top: auto;
  margin-bottom: 5px;
}

.forecast-24h-precipitation {
  text-align: center;
}

@media (max-width: 670px) {
  .forecast-24h-temperature {
    font-size: 12px;
  }

  .forecast-24h-precipitation {
    font-size: 12px;
  }
}

#forecast-daily-container {
  margin-top: 20px;
}

#forecast-daily-cards {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
}

.forecast-daily-card {
  width: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.forecast-daily-title {
  font-size: 18px;
  font-weight: 600;
  align-self: flex-start;
}

.forecast-daily-date {
  align-self: flex-start;
  margin-bottom: 10px;
}

.forecast-daily-icon {
  width: 100px;
}

.forecast-daily-description {
  font-size: 14px;
  margin-bottom: 10px;
}

.forecast-daily-temperature {
  margin-bottom: 10px;
}

#loading-container {
  display: none;
  flex: 5;
  align-items: center;
  justify-content: center;
}

#error-container {
  display: none;
  align-items: center;
  justify-content: center;
  flex: 5;
}

footer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: var(--highlight-color);
  font-family: 'Outfit', sans-serif;
  font-size: 14px;
  font-weight: 300;
}

footer > div {
  width: 250px;
  text-align: center;
}

div.author {
  display: flex;
  justify-content: center;
}

#gh-link {
  text-decoration: none;
  letter-spacing: 0;
  color: var(--font-medium);
  display: flex;
  align-items: center;
  margin: 10px 0;
  height: 38px;
}

#gh-logo {
  width: 35px;
  height: 35px;
  margin: 0 10px;
  transition: transform 0.3s ease-in-out;
}

#gh-link:hover #gh-logo {
  transform: rotate(360deg) scale(1.2);
}

html {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 670px) {
  #weather-container {
    flex-direction: column;
    align-items: center;
    padding-top: 5vh;
  }

  #current-container {
    margin-right: 0;
    margin-bottom: 20px;
    width: 100%;
    align-items: center;
  }

  #current-location-header {
    justify-content: center;
  }

  #forecast-container {
    width: 100%;
  }

  #settings-container {
    position: static;
    top: 0;
    padding-top: 30px;
    padding-bottom: 10px;
  }

  #forecast-daily-cards {
    justify-content: center;
  }

  #location-input {
    width: calc(100vw - 6rem);
    max-width: 300px;
    min-width: 150px;
  }

  footer {
    flex-direction: column;
    padding-top: 20px;
    padding-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA,0DAA0D;;AAE1D;;EAEE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,eAAe;;AAEf;;;;;;;;;;GAUG;;AAEH;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE;IACE,cAAc;IACd,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,wCAAwC;EACxC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n* {\n  box-sizing: border-box;\n  font-family: 'Outfit', sans-serif;\n}\n\n:root {\n  --text-color: #4d4d4d;\n  --text-color-light: #979797;\n}\n\nbody {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  color: var(--text-color);\n}\n\nheader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 100px;\n}\n\nmain {\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n#search-container {\n  flex: 1;\n  margin: 10px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n#search-container > div:first-child {\n  font-weight: 600;\n}\n\n#search-form {\n  margin-top: 10px;\n}\n\n#location-input {\n  padding: 5px 10px;\n  width: 300px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n#location-button {\n  padding: 5px 10px;\n  margin-left: 5px;\n}\n\n#settings-container {\n  position: absolute;\n  right: 50px;\n  top: 50px;\n}\n\n/* Button from https://codepen.io/alvarotrigo/pen/oNoJePo*/\n\n.knobs,\n.layer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.button {\n  position: relative;\n  top: 50%;\n  width: 74px;\n  height: 36px;\n  margin: -20px auto 0 auto;\n  overflow: hidden;\n}\n\n.button.r,\n.button.r .layer {\n  border-radius: 100px;\n}\n\n.checkbox {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.knobs {\n  z-index: 2;\n}\n\n.layer {\n  width: 100%;\n  background-color: #ebf7fc;\n  transition: 0.3s ease all;\n  z-index: 1;\n}\n#metric-imperial-button .knobs:before {\n  content: 'ºC';\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 20px;\n  height: 10px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1;\n  padding: 9px 4px;\n  background-color: #03a9f4;\n  border-radius: 50%;\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n}\n\n#metric-imperial-button .checkbox:checked + .knobs:before {\n  content: 'ºF';\n  left: 42px;\n  background-color: #f44336;\n}\n\n#metric-imperial-button .checkbox:checked ~ .layer {\n  background-color: #fcebeb;\n}\n\n#metric-imperial-button .knobs,\n#metric-imperial-button .knobs:before,\n#metric-imperial-button .layer {\n  transition: 0.3s ease all;\n}\n\n/* End Button */\n\n/* #weather-container {\n  flex: 5;\n  display: none;\n  grid-template-rows: 2fr 2fr 1fr;\n  grid-template-columns: 1fr 1fr;\n  grid-template-areas:\n    'current-container forecast-24h-container'\n    'current-container forecast-daily-container'\n    'spacer-container spacer-container';\n  gap: 20px;\n} */\n\n#weather-container {\n  flex: 5;\n  display: none;\n  flex-direction: row;\n  justify-content: center;\n  padding-top: 10vh;\n  padding: 10vh 10px 0 10px;\n}\n\n#current-container {\n  align-self: flex-start;\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n  align-items: flex-start;\n  margin-right: 20px;\n}\n\n#current-container > div:last-child {\n  display: flex;\n}\n\n#current-location-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  gap: 15px;\n}\n\n#current-city {\n  font-size: 32px;\n  font-weight: 600;\n}\n\n#current-country {\n  font-size: 24px;\n}\n\n#favorite-heart {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n#favorite-heart:hover {\n  transform: scale(1.1);\n}\n\n#last-updated {\n  color: var(--text-color-light);\n  font-size: 13px;\n  margin-bottom: 20px;\n}\n\n#current-weather-icon {\n  width: 150px;\n  height: 150px;\n}\n\n#current-weather-description {\n  text-align: center;\n  font-size: 18px;\n}\n\n#current-conditions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-size: 24px;\n}\n\n#feels-like {\n  color: var(--text-color-light);\n  font-size: 15px;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n#current-precipitation {\n  margin-bottom: 10px;\n}\n\n#wind-direction {\n  width: 100px;\n}\n\n#forecast-container {\n  display: flex;\n  flex-direction: column;\n}\n\n#forecast-24h-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: end;\n}\n\n#forecast-24h-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\n#forecast-24h-cards {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  overflow-x: visible;\n}\n\n@media (max-width: 670px) {\n  #forecast-24h-cards {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 0.5rem;\n    scrollbar-width: thin;\n  }\n}\n\n#forecast-24h-cards::-webkit-scrollbar {\n  height: 6px;\n}\n\n#forecast-24h-cards::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n#forecast-24h-cards::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 3px;\n}\n\n.forecast-24h-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border: 1px solid var(--text-color-light);\n  border-radius: 6px;\n  width: 90px;\n  padding: 0.75rem 0.25rem;\n}\n\n@media (max-width: 670px) {\n  .forecast-24h-card {\n    flex-shrink: 0;\n    padding: 0.75rem 0.5rem;\n    width: 80px;\n  }\n}\n\n.forecast-24h-time {\n  margin-bottom: 5px;\n}\n\n.forecast-24h-description {\n  margin-bottom: 5px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.forecast-24h-temperature {\n  margin-top: auto;\n  margin-bottom: 5px;\n}\n\n.forecast-24h-precipitation {\n  text-align: center;\n}\n\n@media (max-width: 670px) {\n  .forecast-24h-temperature {\n    font-size: 12px;\n  }\n\n  .forecast-24h-precipitation {\n    font-size: 12px;\n  }\n}\n\n#forecast-daily-container {\n  margin-top: 20px;\n}\n\n#forecast-daily-cards {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-start;\n}\n\n.forecast-daily-card {\n  width: 180px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.forecast-daily-title {\n  font-size: 18px;\n  font-weight: 600;\n  align-self: flex-start;\n}\n\n.forecast-daily-date {\n  align-self: flex-start;\n  margin-bottom: 10px;\n}\n\n.forecast-daily-icon {\n  width: 100px;\n}\n\n.forecast-daily-description {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.forecast-daily-temperature {\n  margin-bottom: 10px;\n}\n\n#loading-container {\n  display: none;\n  flex: 5;\n  align-items: center;\n  justify-content: center;\n}\n\n#error-container {\n  display: none;\n  align-items: center;\n  justify-content: center;\n  flex: 5;\n}\n\nfooter {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  background-color: var(--highlight-color);\n  font-family: 'Outfit', sans-serif;\n  font-size: 14px;\n  font-weight: 300;\n}\n\nfooter > div {\n  width: 250px;\n  text-align: center;\n}\n\ndiv.author {\n  display: flex;\n  justify-content: center;\n}\n\n#gh-link {\n  text-decoration: none;\n  letter-spacing: 0;\n  color: var(--font-medium);\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n  height: 38px;\n}\n\n#gh-logo {\n  width: 35px;\n  height: 35px;\n  margin: 0 10px;\n  transition: transform 0.3s ease-in-out;\n}\n\n#gh-link:hover #gh-logo {\n  transform: rotate(360deg) scale(1.2);\n}\n\nhtml {\n  visibility: visible;\n  opacity: 1;\n}\n\n@media (max-width: 670px) {\n  #weather-container {\n    flex-direction: column;\n    align-items: center;\n    padding-top: 5vh;\n  }\n\n  #current-container {\n    margin-right: 0;\n    margin-bottom: 20px;\n    width: 100%;\n    align-items: center;\n  }\n\n  #current-location-header {\n    justify-content: center;\n  }\n\n  #forecast-container {\n    width: 100%;\n  }\n\n  #settings-container {\n    position: static;\n    top: 0;\n    padding-top: 30px;\n    padding-bottom: 10px;\n  }\n\n  #forecast-daily-cards {\n    justify-content: center;\n  }\n\n  #location-input {\n    width: calc(100vw - 6rem);\n    max-width: 300px;\n    min-width: 150px;\n  }\n\n  footer {\n    flex-direction: column;\n    padding-top: 20px;\n    padding-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
